




































































































import {Vue, Component, Ref, Watch, PropSync} from 'vue-property-decorator';
import {Action, Getter} from "vuex-class";
import {SelectWings} from "wings-ui-components";
import { CollapseTransition } from "vue2-transitions";
import {notifyError, notifySuccess} from "@/utils/notify-helper";
import {readFileAsBinary, readFileAsText} from "@/utils/download-helper"
import {AddressBookImportRequest, AddressBookItem} from "@/store/addressbooks/types";
import { getTranslatedParams } from '@/utils/notify-utils';
import { ActionLog } from '@/store/auth/types';

@Component({components: {CollapseTransition,SelectWings}})
export default class ImportContacts extends Vue {
  @Ref('validator') validator: any;
  @PropSync('show') is_show!: boolean;
  @PropSync('group_id') groupId!: number;
  @Getter delimiterList:any;
  @Getter("addressBookItem") addressBookItem: any;
  @Action("importAddressBookContacts") actionImport: any;
  @Action("preImport") actionPreImport: any;
  @Action("getAddressBookItem") actionGetItem: any;
  @Action("actionLog") actionLog: any;

  logObject: ActionLog = {}

  defaultImportRequest(): AddressBookImportRequest {
    return new AddressBookImportRequest(this.groupId)
  }

  importRequest = this.defaultImportRequest()
  file: any = null
  fileKey = 0
  fieldTypes = this.defaultFieldTypes()
  fields = []
  autoImport = true
  isTextFile = false
  dateFormatList = [
    {value: 1, text: 'DD-MM-YYYY'},
    {value: 2, text: 'YYYY-MM-DD'},
    {value: 3, text: 'MM-DD-YYYY'}
  ]
  groupItem: AddressBookItem = {}

  defaultFieldTypes() {
    return ['MSISDN', 'EMAIL', 'NAME', 'SURNAME', 'MIDDLENAME', 'FIELD1', 'FIELD2', 'FIELD3', 'FIELD4', 'FIELD5', 'FIELD6']
  }

  get fieldTypeNames() {
    return this.fieldTypes.map((item:any) => this.$t('contacts.types.'+item))
  }

  async created() {
    if (this.$route.params.id) {
      try {
        this.groupItem = await this.actionGetItem(this.$route.params.id)
      } catch (error) {
        notifyError(error);
      }
    }
  }

  get showCheckDuplicates() {
    // return true
    return 'checkDuplicatesPolicy' in this.groupItem && this.groupItem.checkDuplicatesPolicy != 0
  }

  @Watch('autoImport')
  onAutoImportChanged(val: boolean) {
    if (!val) this.readFile()
  }

  @Watch('importRequest.separator')
  onSeparatorChanged(val: boolean) {
    this.readFile()
  }

  onFileUpload (evt:any) {
    this.file = evt[0]
    this.readFile()
  }

  async readFile() {
    if (this.autoImport) return
    if (!await this.validator.validate()) return
    try {
      this.isTextFile = false
      if (["text/csv", "text/plain"].includes(this.file.type)) {
        this.isTextFile = true
        const fileData = await readFileAsText(this.file)
        // const firstrow = fileData.split('\n').shift() // very slow on big file
        const firstrow = fileData.slice(0, fileData.indexOf("\n"))
        this.fields = firstrow.split(this.importRequest.separator)
      }
      else
      {
        this.fields = await this.actionPreImport({
          separator: this.importRequest.separator,
          fileName: this.importRequest.fileName,
          file: btoa(await readFileAsBinary(this.file))
        })
      }
      this.importRequest.fieldSequence = this.fields.map(() => '')

    } catch (error) {
      console.log(error)
      notifyError(error);
    }
  }

  async importFile():Promise<void> {
    if (!await this.validator.validate()) {
      notifyError(null, this.validator.errors)
      return
    }
    if (!this.autoImport) {
      const isFilled = this.importRequest.fieldSequence.find((item:string) => item == 'MSISDN' || item == 'EMAIL')
      if (!isFilled) {
        notifyError(null, null, this.$t('contacts.messages.requiredMissing').toString())
        return
      }
      const fieldSequenceFiltered = this.importRequest.fieldSequence.filter((item:string) => item != '')
      const isDuplicates = new Set(fieldSequenceFiltered).size !== fieldSequenceFiltered.length
      if (isDuplicates) {
        notifyError(null, null, this.$t('contacts.messages.fieldTypeDuplicates').toString())
        return
      }
    }
    try {
      this.importRequest.groupId = this.groupId
      this.importRequest.file = btoa(await readFileAsBinary(this.file))
      if (this.autoImport) this.importRequest.fieldSequence = this.defaultFieldTypes()

      this.logObject = {
        actionPage: this.$route.meta.msgKey,
        action: "Import",
        actionStatus: 'success',
        objectType: "Contact",
        addititionalInfo: getTranslatedParams({file: this.importRequest.fileName, groupId: this.addressBookItem?.name})
      }

      const data = await this.actionImport(this.importRequest);

      notifySuccess(this.$t('contacts.importSuccess').toString())

      await this.actionLog(this.logObject)

      this.$emit('refresh')
      this.importRequest = this.defaultImportRequest()
      this.fileKey = Date.now()

    } catch (error) {
      notifyError(error);
      await this.actionLog({...this.logObject, actionStatus: 'failed'})
    }
  }
}
